import { render, staticRenderFns } from "./StorageProgressBarGeneric.vue?vue&type=template&id=3cbf7dfc&scoped=true&lang=pug&"
import script from "./StorageProgressBarGeneric.vue?vue&type=script&lang=js&"
export * from "./StorageProgressBarGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf7dfc",
  null
  
)

export default component.exports